"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarketingResourceView = void 0;
/**
 * A builder for MarketingResourceView
 *
 * @param data - The event data
 * @return The formatted event data for MarketingResourceViewEvent
 */
function createMarketingResourceView(data) {
    return {
        name: 'MarketingResourceView',
        environments: ['browser'],
        data: data,
    };
}
exports.createMarketingResourceView = createMarketingResourceView;
//# sourceMappingURL=createMarketingResourceView.js.map